import type { ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { useOrg } from "../lib/org";
import { api } from "../lib/api";
import { CynchAppLauncher } from './CynchAppLauncher';

export function Layout({ children }: { children: ReactNode }) {
  const { orgs, currentOrg, setCurrentOrg, user, refetch } = useOrg();

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      refetch();
    }
  };

  return (
    <div className="min-h-screen">
      <Sidebar />
      <div className="pl-60">
        <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-gray-200 bg-white/90 px-6 backdrop-blur">
          <div className="flex items-center gap-3">
            <label className="text-xs font-medium uppercase tracking-wide text-gray-400">
              Organization
            </label>
            <select
              value={currentOrg?.id ?? ""}
              onChange={(e) => setCurrentOrg(e.target.value)}
              className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium shadow-sm focus:border-brand-500 focus:outline-none"
            >
              {orgs.map((o) => (
                <option key={o.id} value={o.id}>
                  {o.name}
                </option>
              ))}
            </select>
            {currentOrg?.orgCustomerId && (
              <span className="rounded-full bg-gray-100 px-2.5 py-0.5 text-xs text-gray-500">
                org_customer_id: {currentOrg.orgCustomerId}
              </span>
            )}
          </div>
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-500">{user?.email}</span>
            <CynchAppLauncher authenticated={!!user} currentApp="gl" />
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-100 text-sm font-semibold text-brand-700">
              {user?.email?.[0]?.toUpperCase() ?? "?"}
            </span>
            <button
              onClick={logout}
              className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-600 shadow-sm hover:bg-gray-50"
            >
              Sign out
            </button>
          </div>
        </header>
        <main className="mx-auto max-w-6xl px-6 py-8">{children}</main>
      </div>
    </div>
  );
}
